"use client";
import React, { useEffect, useState, useCallback } from "react";
import dynamic from "next/dynamic";
import { get_ir_graph } from "@/spotlight/client";
import { storyblokEditable } from "@storyblok/react";
import Title from "@/library/sections/texts/Title";
import { formatDate } from "@/library/components/formatters/DateTimeFormatters";

const ReactECharts = dynamic(() => import("echarts-for-react"), {
  ssr: false,
});

export default function SpotlightInstrumentStockPriceChartBlock({ blok }) {
  const [chartOptions, setChartOptions] = useState(null);
  const { title, titleColor, titleAs, numberOfDataPoints } = blok;
  const graphDataLimit = numberOfDataPoints || 120;

  const fetchData = useCallback(async () => {
    try {
      const json_ = await get_ir_graph({});
      const graphData = json_.graphValues;

      const chartOptions = {
        xAxis: {
          type: "category",
          data: graphData
            .slice(graphData.length - graphDataLimit, graphData.length)
            .map((item) => formatDate(item.Date)),
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: graphData
              .slice(graphData.length - graphDataLimit, graphData.length)
              .map((item) => item.closePrice),
            type: "line",
          },
        ],
      };

      setChartOptions(chartOptions);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  }, [graphDataLimit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <section
      {...storyblokEditable(blok)}
      className="container max-w-7xl mx-auto p-12 min-h-56"
    >
      <Title
        title={title}
        titleColor={titleColor}
        titleAs={titleAs}
        className="text-center font-bold mb-20"
      />
      {chartOptions && <ReactECharts option={chartOptions} />}
    </section>
  );
}
